<template>
  <div class="bodyback-light pages">
    <notifications></notifications>
    <navmenu></navmenu>

    <div class="container pb-0 pt-md-5 pt-sm-5 pt-5">
      <div class="row justify-content-center">
        <div class="col-xl-4 col-lg-7 forms card-alerts">
          <form action="">
            <div class="text-center custom-col mt-4">
              <h1 class="title-view-2 mb-1">Hello</h1>
              <div class="textInHorizontalLine">
                <span>{{ supplierName }}</span>
              </div>
            </div>

            <div class="card pb-3 mt-4 mb-2">
              <div class="col-12 text-center" v-if="!sendRequest">
                <i class="f-30 text-danger flaticon-traffic-signal"></i>

                <p class="p-content-card text-center mb-2">
                  You are rejected the reservation
                  <span class="strong-lg d-block mt-2">
                    {{ booking_number }}</span
                  >
                </p>
                <p class="p-content-card">
                  To confirm, please select a reason for the rejecting the
                  service
                </p>
                <form role="form" @submit.prevent>
                  <div class="text-left">
                    <b-form-group>
                      <b-form-radio-group
                        id="btn-radios-1"
                        v-model="$v.optionRejected.$model"
                        :options="notes"
                        name="radios-btn-default"
                        value-field="value"
                        text-field="label"
                        tabindex="1"
                        stacked
                        v-bind:class="{
                          'is-invalid': $v.optionRejected.$error
                        }"
                      ></b-form-radio-group>
                    </b-form-group>

                    <small
                      class="invalid-feedback text-center"
                      v-if="$v.optionRejected.$error"
                      >Select a reason</small
                    >
                  </div>

                  <base-alert
                    type="info text-left"
                    class="mb-1 info-min mb-4 p-2"
                    v-if="optionRejected === 'Other'"
                  >
                    <i class="flaticon-circle mr-1"></i>
                    Enter the reason for rejecting the reservation
                  </base-alert>

                  <div
                    class="col-xl-12 p-0"
                    v-if="optionRejected === 'Other'"
                    v-bind:class="{ 'is-invalid': $v.reason.$error }"
                  >
                    <label class="title-label">*Other Reason</label>
                    <el-input
                      v-model="$v.reason.$model"
                      placeholder="Other Reason"
                      id="reason"
                      name="reason"
                      maxlength="200"
                      type="textarea"
                      :autosize="{ minRows: 1, maxRows: 5 }"
                      show-word-limit
                    >
                    </el-input>

                    <small
                      class="invalid-feedback text-left"
                      v-if="$v.reason.$error"
                      >Enter a other reason</small
                    >
                  </div>

                  <base-alert
                    type="info text-left"
                    class="mb-1 info-min mb-4 p-2"
                    v-if="optionRejected === 'Wrong Service Rate'"
                  >
                    <i class="flaticon-circle mr-1"></i>
                    Enter updated rate amount
                  </base-alert>

                  <div
                    class="col-xl-12 p-0"
                    v-if="optionRejected === 'Wrong Service Rate'"
                    v-bind:class="{ 'is-invalid': $v.updateRate.$error }"
                  >
                    <label class="title-label">Update Rate</label>
                    <BaseNumberInput
                      v-model.number="$v.updateRate.$model"
                      placeholder="updateRate"
                      id="updateRate"
                      name="updateRate"
                      maxlength="45"
                      markrequired
                    />
                    <small
                      class="invalid-feedback text-left"
                      v-if="$v.updateRate.$error"
                      >Enter a update Rate</small
                    >
                  </div>

                  <base-alert
                    type="info text-left"
                    class="mb-1 info-min mb-4 p-2"
                    v-if="optionRejected === 'No Availability'"
                  >
                    <i class="flaticon-circle mr-1"></i>
                    If you have availability on a different date/time please let
                    us know below, otherwise leave blank
                  </base-alert>

                  <div
                    class="col-xl-12 p-0"
                    v-if="optionRejected === 'No Availability'"
                    v-bind:class="{ 'is-invalid': $v.newAvailability.$error }"
                  >
                    <label class="title-label">Available Date or Time</label>
                    <base-input
                      v-model="$v.newAvailability.$model"
                      placeholder="newAvailability"
                      id="newAvailability"
                      name="newAvailability"
                      maxlength="45"
                      markrequired
                    >
                    </base-input>

                    <small
                      class="invalid-feedback text-left"
                      v-if="$v.newAvailability.$error"
                      >{{
                        !$v.newAvailability.minLength ||
                        $v.newAvailability.$error
                          ? `Minimum ${$v.newAvailability.$params.minLength.min} and Maximun ${$v.newAvailability.$params.maxLength.max} characters.`
                          : ""
                      }}</small
                    >
                  </div>

                  <div class="text-center border-top py-2">
                    <base-button
                      type="primary"
                      class="min-button mb-0 btn-primary-pages"
                      @click="rejectReservation()"
                      ><i class="flaticon-send"></i> Send</base-button
                    >
                  </div>
                </form>

                <div class="text-center border-top pt-2">
                  <span class="info-card text-center mb-0 ">
                    For assistance please contact us
                    <a href="mailto:info@rhomtrip.com">info@rhomtrip.com</a>
                  </span>
                </div>
              </div>

              <div class="col-12 text-center" v-else>
                <i
                  class="f-30"
                  v-bind:class="[
                    { 'text-success flaticon-check-3': isRejected },
                    { 'text-warning flaticon-traffic-signal': isCancelled },
                    { 'text-warning flaticon-traffic-signal': isFinished },
                    { 'text-warning flaticon-traffic-signal': isStarted },
                    { 'text-danger flaticon-traffic-signal': isReassigned },
                    {
                      'text-danger flaticon-traffic-signal': isPreviouslyDeclined
                    },
                    { 'text-danger flaticon-error': isAnError }
                  ]"
                ></i>

                <p class="p-content-card text-center">
                  The Reservation
                  <span class="strong-lg d-block"> {{ booking_number }}</span>
                  <span v-if="isRejected"
                    >has been <strong>Rejected.</strong>
                  </span>
                  <span v-if="isCancelled">
                    has been <strong> Cancelled.</strong>
                  </span>
                  <span v-if="isFinished">
                    has been <strong> Finished.</strong>
                  </span>
                  <span v-if="isStarted">
                    has been <strong> Started.</strong>
                  </span>
                  <span v-if="isReassigned"
                    >has been reassigned to another partner.
                  </span>
                  <span v-if="isPreviouslyDeclined"
                    >This reservation was previously declined
                  </span>
                  <span v-if="isAnError"
                    >couldn't be rejected. An error occurred while rejecting
                    this reservation. Please try again.</span
                  >
                </p>

                <div class="text-center border-top pt-2">
                  <span class="info-card text-center mb-0 ">
                    For assistance please contact us
                    <a href="mailto:info@rhomtrip.com">info@rhomtrip.com</a>
                  </span>
                </div>
              </div>
            </div>

            <div class="loading mt-3" v-if="load">
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <layoutFooter class="footer-pages"></layoutFooter>
  </div>
</template>

<script>
import Navbarpages from "@/views/Layout/Navbarpages";
import endpoint from "../../Commons/Services";
import layoutFooter from "../../Layout/ContentFooter.vue";

import {
  decimal,
  required,
  minLength,
  maxLength,
  requiredIf,
  minValue
} from "vuelidate/lib/validators";

export default {
  components: {
    navmenu: Navbarpages,
    layoutFooter: layoutFooter
  },
  data() {
    return {
      optionRejected: "",
      supplierName: "",
      booking_number: "",
      notes: [
        { value: "No Availability", label: "No Availability" },
        { value: "Wrong Service Rate", label: "Wrong Service Rate" },
        { value: "Other", label: "Other" }
      ],
      load: false,
      other_reason: "",
      statusAlert: "",
      reason: "",
      updateRate: "",
      newAvailability: "",
      currency: {
        code: "",
        symbol: "",
        label: ""
      },
      isRejected: false,
      isCancelled: false,
      isFinished: false,
      isStarted: false,
      isReassigned: false,
      isPreviouslyDeclined: false,
      isAnError: false,
      sendRequest: false,
      accesToken: "",
      operatorId: null
    };
  },
  async created() {
    this.operatorId = this.$route.params.supplier_id
      ? this.$route.params.supplier_id
      : null;

    this.supplierName = this.$route.query.supplierName
      ? this.$route.query.supplierName
      : "";
    this.accesToken = this.$route.query.token ? this.$route.query.token : "";
    await this.getReservationById(this.$route.params.id);
  },
  methods: {
    /**
     * Load the reservation and populate booking number, supplier name,
     * currency and operatorId (used later to detect a reassignment).
     * @param {string} reservationId - Reservation identifier.
     * @returns {Promise<void>}
     */
    async getReservationById(reservationId) {
      try {
        this.load = true;
        let { data } = await endpoint.reservations.services.getReservation(
          reservationId
        );
        this.load = false;
        if (data.data) {
          let result = data.data;
          this.booking_number = result.booking_number;
          this.supplierName = this.supplierName
            ? this.supplierName
            : result.supplier.businessDetails.name;
          this.currency = {
            code: result.service.currency_code,
            symbol: result.service.currency_symbol,
            label: result.service.currency_label
          };
        } else {
          this.booking_number = "";
        }
      } catch (error) {
        this.load = false;
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The Operation could not be completed. Please try again",
          icon: "flaticon-error"
        });
      }
    },
    /**
     * Validate the rejection form and, if valid, submit the reservation
     * rejection with the reason built from the selected option.
     * @returns {Promise<void>}
     */
    async rejectReservation() {
      if (!this.$v.$invalid) {
        let reservationId = this.$route.params.id;
        let payload = {
          reason: this.getReason(this.optionRejected)
        };
        await this.rejectReservationById(reservationId, payload);
      } else {
        this.$v.$touch();
        this.$notify({
          type: "warning",
          title: "Warning",
          message: "Please complete the required attributes",
          icon: "flaticon-warning-1"
        });
      }
    },
    /**
     * Send the rejection request and resolve the resulting reservation
     * status into the isReassigned/isCancelled/isFinished/isStarted/
     * isRejected view state, in that priority order.
     * @param {string} reservationId - Reservation identifier.
     * @param {Object} payload - Rejection payload (e.g. { note }).
     * @returns {Promise<void>}
     */
    async rejectReservationById(reservationId, payload) {
      try {
        this.load = true;
        this.sendRequest = false;
        let {
          data
        } = await endpoint.reservations.services.rejectReservationById(
          reservationId,
          payload,
          this.accesToken
        );
        this.load = false;
        this.sendRequest = true;

        if (!data) {
          this.isAnError = true;
          return;
        }

        const isCancelled = this.isReservationCanceled(data.status);
        const isFinished = this.isReservationFinished(data.status);
        const isStarted = this.isReservationStarted(data.status);
        const isRejected = this.isReservationRejected(data.status);
        const isReassigned =
          data.supplier != null && data.supplier !== this.operatorId;

        if (isReassigned) {
          this.isReassigned = true;
          return;
        }

        if (isCancelled) {
          this.isCancelled = true;
          return;
        }

        if (isFinished) {
          this.isFinished = true;
          return;
        }

        if (isStarted) {
          this.isStarted = true;
          return;
        }

        if (isRejected) {
          this.isPreviouslyDeclined = true;
          return;
        }

        this.isRejected = true;
        return;
      } catch (error) {
        this.load = false;
        this.sendRequest = true;
        this.isAnError = true;
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The Operation could not be completed. Please try again",
          icon: "flaticon-error"
        });
      }
    },
    /**
     * Build the rejection note text for the selected reason option.
     * @param {string} optionRejected - One of "No Availability",
     *   "Wrong Service Rate", "Other", or empty.
     * @returns {string} Note to send as the rejection reason.
     */
    getReason(optionRejected) {
      if (optionRejected === "No Availability") {
        return this.newAvailability
          ? `Available on the following date/time: ${this.newAvailability}`
          : "No Availability";
      } else if (optionRejected === "Wrong Service Rate") {
        return `Update Rate: ${this.updateRate} ${this.currency.code}`;
      } else if (optionRejected === "Other") {
        return `${this.reason}`;
      }
      return "";
    },
    /**
     * @param {string} status - Reservation status code.
     * @returns {boolean} True if the reservation was cancelled.
     */
    isReservationCanceled(status) {
      return ["SBC", "SCB"].includes(status);
    },
    /**
     * @param {string} status - Reservation status code.
     * @returns {boolean} True if the reservation has finished.
     */
    isReservationFinished(status) {
      return status === "JF";
    },
    /**
     * @param {string} status - Reservation status code.
     * @returns {boolean} True if the service is currently in progress.
     */
    isReservationStarted(status) {
      const startedStatuses = [
        "DA",
        "OTW",
        "POB",
        "DAP",
        "DRR",
        "DSR",
        "PSA",
        "DAD"
      ];
      return startedStatuses.includes(status);
    },
    /**
     * @param {string} status - Reservation status code.
     * @returns {boolean} True if the reservation was already rejected.
     */
    isReservationRejected(status) {
      return ["SRB"].includes(status);
    }
  },
  validations: {
    optionRejected: {
      required
    },
    reason: {
      minLength: minLength(10),
      maxLength: maxLength(200),
      required: requiredIf(function(value) {
        return this.$v.optionRejected.$model === "Other";
      })
    },
    updateRate: {
      decimal,
      minValue: minValue(0.01),
      required: requiredIf(function(value) {
        return this.$v.optionRejected.$model === "Wrong Service Rate";
      })
    },
    newAvailability: {
      minLength: minLength(2),
      maxLength: maxLength(45)
    }
  }
};
</script>
